import React from "react";
import cx from "classnames";
import getEnvEndpoints from "../../../utils/endpoints";

const endpoints = getEnvEndpoints();

const CardPreviewImage = ({ previewImage, isExpandable }) => {
  const filePath = previewImage && previewImage.startsWith("http")
    ? previewImage
    : `${endpoints.baseContentUrl}${previewImage}`;
  return (
    <img
      src={filePath}
      className={cx("mb-5 block w-full", { "cursor-pointer": isExpandable })}
      alt="preview"
    />
  );
};

export default CardPreviewImage;
